export default __webpack_public_path__ + "627f446218ef7e9993d3bdeb55bd044f.svg";